/**
 * 统一监控平台左侧树相关的reducer
 */
import { combineReducers } from 'redux'
import {
  SET_DEVICEMONITORTREEDATA,
  SET_AREADATA,
  SET_DEVICERESOURCEDEPENDTREEDATA,
  SET_DEVICE_MONITOR_TREE_MAP,
  SET_TREE_STORE,
  SET_RESOURCE_PANEL_SHOW,
  SET_RESOURCE_PANEL_TYPE,
  SET_RESOURCE_PANEL_DRAWER_SHOW,
  SET_ALLEQUIPMENTANDMONITORDATA,
  SET_STATESTATISTICSDATA,
  SET_TREEMAPDATA,
  SET_HISTORYSTATUSMAP,
  SET_ALLSTATESTATISTICSPECENTDATA
} from '../actions/deviceMonitorTree_action'

function deviceMonitorTreeData(state = [], action) {
    switch (action.type) {
        case SET_DEVICEMONITORTREEDATA:
            return action.deviceMonitorTreeData
        default:
            return state
    }
}

function areaData(state = [], action) {
    switch (action.type) {
        case SET_AREADATA:
            return action.areaData
        default:
            return state
    }
}

function deviceResourceDependTreeData(state = [], action) {
    switch (action.type) {
        case SET_DEVICERESOURCEDEPENDTREEDATA:
            return action.deviceResourceDependTreeData
        default:
            return state
    }
}

function deviceMonitorTreeMap(state = {}, action) {
    switch (action.type) {
        case SET_DEVICE_MONITOR_TREE_MAP:
            return action.deviceMonitorTreeMap
        default:
            return state
    }
}

function treeStore(state = [], action) {
    switch (action.type) {
        case SET_TREE_STORE:
            return action.treeStore
        default:
            return state
    }
}

function resourcePanelShow(state = false, action) {
    switch (action.type) {
        case SET_RESOURCE_PANEL_SHOW:
            return action.resourcePanelShow
        default:
            return state
    }
}

function resourcePanelType(state = '', action) {
    switch (action.type) {
        case SET_RESOURCE_PANEL_TYPE:
            return action.resourcePanelType
        default:
            return state
    }
}

function resourcePanelDrawerShow(state = false, action) {
    switch (action.type) {
        case SET_RESOURCE_PANEL_DRAWER_SHOW:
            return action.resourcePanelDrawerShow
        default:
            return state
    }
}

function allEquipmentAndMonitorData(state = [], action) {
  switch (action.type) {
    case SET_ALLEQUIPMENTANDMONITORDATA:
      return action.allEquipmentAndMonitorData;
    default:
      return state;
  }
}

function stateStatisticsData(state = [], action) {
  switch (action.type) {
    case SET_STATESTATISTICSDATA:
      return action.stateStatisticsData;
    default:
      return state;
  }
}

function allStateStatisticsPecentData(state = {}, action) {
  switch (action.type) {
    case SET_ALLSTATESTATISTICSPECENTDATA:
      return action.allStateStatisticsPecentData;
    default:
      return state;
  }
}

function treeMapData(state = [], action) {
  switch (action.type) {
    case SET_TREEMAPDATA:
      return action.treeMapData;
    default:
      return state;
  }
}

function historyStatusMap(state = {}, action) {
  switch (action.type) {
    case SET_HISTORYSTATUSMAP:
      return action.historyStatusMap;
    default:
      return state;
  }
}

const deviceMonitorTreeReducer = combineReducers({
  deviceMonitorTreeData,
  areaData,
  deviceResourceDependTreeData,
  deviceMonitorTreeMap,
  treeStore,
  resourcePanelShow,
  resourcePanelType,
  resourcePanelDrawerShow,
  allEquipmentAndMonitorData,
  stateStatisticsData,
  treeMapData,
  historyStatusMap,
  allStateStatisticsPecentData
})

export default deviceMonitorTreeReducer
